import React from 'react';
import Carousel from '@ertelecom/ui-react/components/carousel';
import { CarouselSlide } from './carousel-slide';
import * as ST from './styled';

const slideWidth = 178;
const slideMargin = 22;
const slidesToShow = 10;

const breakpoints = [
    { width: 319, slidesToShow },
];

const settingsCarousel = {
    responsive: breakpoints,
    infinite: true,
    autoplay: false,
    showArrows: false,
    autoplayDelay: 2000,
    autoplaySpeed: 3000,
};

export const FilmsCarousel = ({ data = [] }) => {
    const lentWidth = slidesToShow * (slideWidth + slideMargin);

    return (
        <ST.Slider>
            <ST.SliderLent lentWidth={lentWidth} outMargin={slideMargin}>
                <Carousel {...settingsCarousel}>
                    {data.map((slide, index) => {
                        return (
                            <CarouselSlide
                                key={index}
                                slide={slide}
                                slideWidth={slideWidth}
                                slideMargin={slideMargin}
                            />
                        );
                    })}
                </Carousel>
            </ST.SliderLent>
        </ST.Slider>
    );
};
